// $(document).ready(function(){
    
//     $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_prev', function(){
//         $('product-gallery .slider-button--prev').trigger('click');
//     });
//     $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_next', function(e) {
//         $('product-gallery .slider-button--next').trigger('click');
//     });

//     setInterval(() => {
//         if ($('product-gallery .slider-button--prev').prop('disabled')) {
//             $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').addClass('disabled');
//         } else {
//             $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').removeClass('disabled');
//         }
//         if ($('product-gallery .slider-button--next').prop('disabled')) {
//             $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').addClass('disabled');
//         } else {
//             $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').removeClass('disabled');
//         }
        
//     }, 1000);
    
//     function videoAutoplay(){
//         let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
//              $('product-gallery .slider__slide').each(function(){
//                 var mainMedia = $(this).attr('data-media-id');
//                 if(mainMedia == currentVideo) {
//                    $(this).find('.deferred-media__poster').trigger('click');
//                    $(this).find('video').trigger('play');
//                 }
                
//              });
//     }
    
//     $(document).on('click', 'thumbnail-slider .custom_arrow', function(){
//         setTimeout(() => {
//              videoAutoplay();
//         }, 1200);
//     })
//     $(document).on('click', 'product-gallery .slider-button', function(){
//         setTimeout(() => {
//              let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
//              $('product-gallery .slider__slide').each(function(){
//                 var mainMedia = $(this).attr('data-media-id');
//                 if(mainMedia == currentVideo) {
//                    $(this).find('.deferred-media__poster').trigger('click');
//                    $(this).find('video').trigger('play');
//                 }
                
//              });
//         }, 1200);
//     });

// //     var tumblength = $('thumbnail-slider .thumbnail-list li').length();
// // console.log(tumblength);



// function hideShowVariantsImage(){

// var currentVariantSelect = '';

// $('.custom_hide_show_varaint_images variant-selects .product-form__input input:checked').each(function(){
//     let singleOption = $(this).val();
//     currentVariantSelect += singleOption + ' ';
//     console.log(singleOption);
// });

// console.log(currentVariantSelect.trim());

// $('.custom_hide_show_varaint_images product-gallery .product__media-list .product__media-item').attr('data-gang-option', '');
// $('.custom_hide_show_varaint_images product-gallery .product__media-list .product__media-item').each(function(){
//     var GetAlt = $(this).attr('alt');
//     if(GetAlt == currentVariantSelect.trim()){
//         $(this).addClass('gang__active');
//     }else {
//         $(this).removeClass('gang__active');
//     }
// });

// $('.custom_hide_show_varaint_images .thumbnail-slider .thumbnail-list .thumbnail-list__item').attr('data-gang-option', '');
// $('.custom_hide_show_varaint_images .thumbnail-slider .thumbnail-list .thumbnail-list__item').each(function(){
//     var GetAlt = $(this).attr('alt');
//     if(GetAlt == currentVariantSelect.trim()){
//         $(this).addClass('gang__active');
//     }else {
//         $(this).removeClass('gang__active');
//     }
// }); 

// }

// hideShowVariantsImage();

// $(document).on('click', 'variant-selects .product-form__input label', function(){
//     hideShowVariantsImage(); 
  
// })

// });



// custom
$(document).ready(function(){
    
    // Thumbnail slider custom arrows
    $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_prev', function(){
        $('product-gallery .slider-button--prev').trigger('click');
    });
    $(document).on('click', '.show_thumbnails_with_arrows .thumbnail-slider .custom_next', function(e) {
        $('product-gallery .slider-button--next').trigger('click');
    });

    setInterval(() => {
        if ($('product-gallery .slider-button--prev').prop('disabled')) {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').addClass('disabled');
        } else {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_prev').removeClass('disabled');
        }
        if ($('product-gallery .slider-button--next').prop('disabled')) {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').addClass('disabled');
        } else {
            $('.show_thumbnails_with_arrows .thumbnail-slider .custom_next').removeClass('disabled');
        }
    }, 1000);
    
    function videoAutoplay(){
        let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
        $('product-gallery .slider__slide').each(function(){
            var mainMedia = $(this).attr('data-media-id');
            if(mainMedia == currentVideo) {
               $(this).find('.deferred-media__poster').trigger('click');
               $(this).find('video').trigger('play');
            }
        });
    }
    
    $(document).on('click', 'thumbnail-slider .custom_arrow', function(){
        setTimeout(() => {
             videoAutoplay();
        }, 1200);
    });

    $(document).on('click', 'product-gallery .slider-button', function(){
        setTimeout(() => {
             let currentVideo = $('.video.thumbnail[aria-current="true"]').closest('.thumbnail-list__item').attr('data-target');
             $('product-gallery .slider__slide').each(function(){
                var mainMedia = $(this).attr('data-media-id');
                if(mainMedia == currentVideo) {
                   $(this).find('.deferred-media__poster').trigger('click');
                   $(this).find('video').trigger('play');
                }
             });
        }, 1200);
    });

    var previousVariantSelect = '';

    function hideShowVariantsImage(){
        var selectedOptions = [];

        // Scope to visible, primary variant selector
        var $primaryPicker = $('.custom_hide_show_varaint_images variant-selects[data-primary]:not([style*="display: none"])');
        if (!$primaryPicker.length) {
            $primaryPicker = $('.custom_hide_show_varaint_images variant-selects:visible');
        }
        if (!$primaryPicker.length) {
            $primaryPicker = $('.custom_hide_show_varaint_images variant-selects:first');
        }

        // Extract 1 value per option fieldset/dropdown
        $primaryPicker.find('.product-form__input').each(function(){
            var singleOption = $(this).find('input:checked, select option:selected').val();
            if (singleOption) {
                selectedOptions.push(singleOption.trim());
            }
        });

        var currentVariantSelect = selectedOptions.join(' ').trim();
        if (!currentVariantSelect) return;

        // If the variant hasn't changed, do not re-run animation
        if (currentVariantSelect === previousVariantSelect) return;
        previousVariantSelect = currentVariantSelect;

        // Remove data-gang-option to avoid theme conflict
        $('.custom_hide_show_varaint_images .product__media-item, .custom_hide_show_varaint_images .thumbnail-list__item').removeAttr('data-gang-option');

        // Filter main gallery slides directly (triggers animation once)
        $('.custom_hide_show_varaint_images product-gallery .product__media-list .product__media-item').each(function(){
            var getAlt = ($(this).attr('alt') || '').trim();
            if (getAlt === currentVariantSelect) {
                $(this).css('display', 'block');
            } else {
                $(this).css('display', 'none');
            }
        });

        // Filter thumbnails directly
        $('.custom_hide_show_varaint_images .thumbnail-slider .thumbnail-list .thumbnail-list__item').each(function(){
            var getAlt = ($(this).attr('alt') || '').trim();
            if (getAlt === currentVariantSelect) {
                $(this).css('display', 'block');
            } else {
                $(this).css('display', 'none');
            }
        });

        // Recalculate slider slides & reset to first slide
        var productGallery = document.querySelector('.custom_hide_show_varaint_images product-gallery');
        if (productGallery) {
            if (typeof productGallery.resetPages === 'function') {
                productGallery.resetPages();
            }
            if (typeof productGallery.goToFirstSlide === 'function') {
                productGallery.goToFirstSlide();
            }
        }

        var thumbnailSlider = document.querySelector('.custom_hide_show_varaint_images thumbnail-slider');
        if (thumbnailSlider && typeof thumbnailSlider.resetPages === 'function') {
            thumbnailSlider.resetPages();
        }
    }

    // 1. Run on initial page load
    hideShowVariantsImage();

    // 2. Run on radio/dropdown change event
    $(document).on('change', '.custom_hide_show_varaint_images variant-selects', function(){
        setTimeout(hideShowVariantsImage, 20);
    });

    // 3. Fallback for Safari label clicks
    $(document).on('click', '.custom_hide_show_varaint_images variant-selects .product-form__input label', function(){
        setTimeout(hideShowVariantsImage, 50);
    });

    // 4. Hook into theme PubSub
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function() {
            setTimeout(hideShowVariantsImage, 20);
        });
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function() {
            setTimeout(hideShowVariantsImage, 20);
        });
    }

});


